/**
 * @file mediago模块的路径，组件，菜单，权限相关配置
 * @author  fangsimin
 * @date    2020-02-09 17:49:50
 * @last Modified by    fangsimin
 * @last Modified time  2020-02-09 21:39:03
 */

const env = process.env;
const module = env['MODULE_CMP'];

// 菜单展开配置
// 路径，组件菜单配置
// 路径：必须包含key
// 组件：必须包含title
const config = [
    {
        icon: 'effectMgr',
        key: 'effectMgr',
        showMenu: true,
        title: 'cmp.menuData.effectMgr',
        children: [
            {
                id: '1',
                // icon: 'dashboard',
                path: '/dashboard',
                key: 'dashboard',
                showMenu: true,
                title: 'cmp.menuData.dashboard',
                component: resolve => require(['@/modules/cmp/pages/dashboard/index'], resolve)
            },
            {
                id: '4',
                // icon: 'data-report',
                path: '/overview',
                key: 'overview',
                showMenu: true,
                title: 'cmp.menuData.dataReport',
                component: resolve => require(['@/modules/cmp/pages/dataReport/report'], resolve)
            },
            {
                // icon: 'hour-data',
                path: '/hour-data',
                key: 'hour-data',
                showMenu: true,
                title: 'cmp.menuData.hour-data',
                component: resolve => require(['@/modules/cmp/pages/entityHourdata/index'], resolve)
            },
            {
                // icon: 'analysis',
                path: '/account-analysis',
                key: 'account-analysis',
                showMenu: true,
                title: 'cmp.menuData.account-analysis',
                component: resolve => require(['@/modules/cmp/pages/accountAnalysis/index'], resolve)
            },
            {
                path: '/operation-log',
                key: 'operation-log',
                showMenu: true,
                title: 'cmp.menuData.operation-log',
                component: resolve => require(['@/modules/cmp/pages/operationLog/index'], resolve)
            }
        ]
    },
    {
        icon: 'batchMgr',
        key: 'bulk-tools',
        showMenu: true,
        title: 'cmp.menuData.batchMgr',
        children: [
            {
                id: '85',
                path: '/bulk-tools/creative',
                key: 'creative',
                showMenu: true,
                title: 'cmp.menuData.creative-upload',
                component: resolve => require(['@/modules/cmp/pages/bulkTools/creative.vue'], resolve)
            },
            {
                id: '86',
                path: '/bulk-tools/ads',
                key: 'ads',
                showMenu: true,
                title: 'cmp.menuData.ads-upload',
                component: resolve => require(['@/modules/cmp/pages/bulkTools/ads.vue'], resolve)
            }
        ]
    },
    {
        icon: 'creativeMgr',
        key: 'creativeMgr',
        showMenu: true,
        title: 'cmp.menuData.creativeMgr',
        children: [
            {
                id: '7',
                // icon: 'creative',
                path: '/creative',
                key: 'creative',
                showMenu: true,
                title: 'cmp.menuData.creative',
                component: resolve => require(['@/modules/cmp/pages/creative/index'], resolve)
            },
            {
                id: '11',
                // icon: 'creative-rejection',
                path: '/creative-rejection',
                key: 'creative-rejection',
                showMenu: true,
                title: 'cmp.menuData.creative-rejection',
                component: resolve => require(['@/modules/cmp/pages/creative/rejection'], resolve)
            },
            {
                id: '12',
                // icon: 'creative-external',
                path: '/creative-external',
                key: 'creative-external',
                showMenu: true,
                title: 'cmp.menuData.creative-external',
                component: resolve => require(['@/modules/cmp/pages/creative/creativeLibrary'], resolve)
            }
        ]
    },
    {
        icon: 'businessMgr',
        key: 'businessMgr',
        showMenu: true,
        title: 'cmp.menuData.businessMgr',
        children: [
            // {
            //     id: '5',
            //     // icon: 'finance',
            //     path: '/finance',
            //     key: 'finance',
            //     showMenu: true,
            //     title: 'cmp.menuData.finance',
            //     component: resolve => require(['@/modules/cmp/pages/finance/index'], resolve)
            // },
            {
                icon: 'financeMgr',
                key: 'finance',
                // path: '/permission-settings',
                showMenu: true,
                title: 'cmp.menuData.finance',
                // redirect: '/finance/finance-estimate',
                children: [
                    {
                        // icon: 'finance-estimate',
                        path: '/finance/finance-estimate',
                        key: 'finance-estimate',
                        showMenu: true,
                        title: 'cmp.menuData.finance-estimate',
                        component: resolve => require(['@/modules/cmp/pages/finance/index'], resolve)
                    },
                    {
                        // icon: 'recharge',
                        path: '/finance/recharge',
                        key: 'recharge',
                        showMenu: true,
                        title: 'cmp.menuData.recharge',
                        component: resolve => require(['@/modules/cmp/pages/financeMgr/recharge/recharge'], resolve)
                    },
                    {
                        // icon: 'recharge-log',
                        path: '/finance/recharge-log',
                        key: 'recharge-log',
                        showMenu: true,
                        title: 'cmp.menuData.recharge-log',
                        component: resolve => require(['@/modules/cmp/pages/financeMgr/record'], resolve)
                    }
                ]
            },
            {
                icon: 'customRelationMgr',
                key: 'customer-relationship',
                showMenu: true,
                title: 'cmp.menuData.customer-relationship',
                children: [
                    {
                        id: '3',
                        // icon: 'account',
                        path: '/customer-relationship/account',
                        key: 'account',
                        showMenu: true,
                        title: 'cmp.menuData.account',
                        component: resolve => require(['@/modules/cmp/pages/accountMgr/audit'], resolve)
                    },
                    {
                        id: '34',
                        path: '/customer-relationship/agency',
                        key: 'agency',
                        showMenu: true,
                        title: 'cmp.menuData.agency',
                        component: resolve => require(['@/modules/cmp/pages/accountMgr/agent'], resolve)
                    },
                    {
                        id: '35',
                        // icon: 'account',
                        path: '/customer-relationship/team',
                        key: 'team',
                        showMenu: true,
                        title: 'cmp.menuData.team',
                        component: resolve => require(['@/modules/cmp/pages/accountMgr/team'], resolve)
                    }
                ]
            },
            {
                icon: 'authorMgr',
                key: 'permission-settings',
                // path: '/permission-settings',
                showMenu: true,
                title: 'cmp.menuData.authorMgr',
                children: [
                    {
                        id: '94',
                        icon: '',
                        showMenu: true,
                        path: '/permission-settings/role-settings',
                        key: 'role-settings',
                        title: 'cmp.menuData.role-settings',
                        component: resolve => require(['@/modules/cmp/pages/authorMgr/roles'], resolve)
                    },
                    {
                        id: '67',
                        icon: '',
                        showMenu: true,
                        path: '/permission-settings/members',
                        key: 'members',
                        title: 'cmp.menuData.members',
                        component: resolve => require(['@/modules/cmp/pages/authorMgr/index'], resolve)
                    },
                    {
                        id: '97',
                        icon: '',
                        showMenu: true,
                        path: '/permission-settings/uri-list',
                        key: 'uri-list',
                        title: 'cmp.menuData.uri-list',
                        component: resolve => require(['@/modules/cmp/pages/authorMgr/uri'], resolve)
                    },
                    {
                        id: '95',
                        icon: '',
                        showMenu: true,
                        path: '/permission-settings/menu-settings',
                        key: 'menu-settings',
                        title: 'cmp.menuData.menu-settings',
                        component: resolve => require(['@/modules/cmp/pages/authorMgr/function'], resolve)
                    }
                ]
            }
            // {
            //     id: '6',
            //     path: '/help-center-edit',
            //     key: 'help-center-edit',
            //     showMenu: true,
            //     title: 'cmp.menuData.help-center-edit',
            //     component: resolve => require(['@/modules/cmp/pages/FAQ/manage'], resolve)
            // }
        ]
    },
    {
        // id: '6',
        icon: 'faq',
        // path: '/help-center',
        key: 'help-center',
        showMenu: true,
        title: 'cmp.menuData.help-center',
        children: [
            {
                path: '/help-center/doc',
                key: 'doc',
                showMenu: true,
                title: 'cmp.menuData.help-center-doc',
                component: resolve => require(['@/modules/cmp/pages/FAQ/index.vue'], resolve)
            },
            {
                path: '/help-center/edit',
                key: 'edit',
                showMenu: true,
                title: 'cmp.menuData.help-center-edit',
                component: resolve => require(['@/modules/cmp/pages/FAQ/manage.vue'], resolve)
            }
        ]
    }
];

const specialArr = ['effectMgr', 'batchMgr', 'creativeMgr', 'businessMgr'];

/**
 * 获取真正的路径
 * @param  {string} path 路径
 * @param  {boolean} hasModule 是否包含模块
 * @return {string}
 */
function getModulePath(path, hasModule = true) {
    // console.log(path, 'path');
    let pathName = path.split('/')[0];
    if (specialArr.indexOf(pathName) > -1) {
        path = path.replace(`${pathName}/`, '');
    }
    // console.log(path, '----');
    return path
        ? (hasModule ? [env['BASE_URI'], module, path]
            : [env['BASE_URI'], path]).join('/').replace('//', '/')
        : '/';
}

/**
 * 通过前面的config配置，获取menu和路径配置
 *
 * @param  {Object} config [description]
 * @return {Object}        [description]
 */
function getConfig(config) {
    let routerConfig = [];
    let path = {};
    let menu = config.reduce((ret, item) => {
        if (item['key']) {
            if (item['title']) {
                // item['title'] = this.$i18n.t(item['title']);
                if (item['children']) {
                    item['children'] = item['children'].reduce((ret, child) => {
                        if (child['key']) {
                            if (child['title']) {
                                // child['title'] = this.$i18n.t(child['title']);
                                item['showMenu'] && ret.push(child);
                            }
                            let keys = [item['key'], child['key']];
                            path[keys.join('_')] = getModulePath(keys.join('/'));
                            if (child['component']) {
                                // let componentPath = ['@/modules', module, 'pages', ...keys].join('/');
                                // console.log(componentPath);
                                routerConfig.push({
                                    path: path[keys.join('_')],
                                    component: child['component']
                                });
                            }
                        }
                        return ret;
                    }, []);
                }
                item['showMenu'] && ret.push(item);
            }
            path[item['key']] = getModulePath(item['key']);
            if (item['component']) {
                routerConfig.push({
                    path: path[item['key']],
                    component: item['component']
                });
            }
        }
        return ret;
    }, []);
    // console.log(menu, path, routerConfig);
    return {
        menu,
        path,
        routes: routerConfig
    };
}
export default getConfig(config);



// WEBPACK FOOTER //
// ./src/modules/cmp/constants/truePathConfig.js